module.exports = __webpack_public_path__ + "img/9788998157289.8c38abac.jpg";